import { render, staticRenderFns } from "./question-10.vue?vue&type=template&id=275a282b&scoped=true&lang=pug"
var script = {}
import style0 from "./question-10.vue?vue&type=style&index=0&id=275a282b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275a282b",
  null
  
)

export default component.exports